export function paramsToObject(entries: IterableIterator<[string, string]>) {
    const result = {};
    for (const [key, value] of entries) {
        result[key] = value;
    }
    return result;
}
